<template>
    <div>
        <!-- 公众号二维码弹出层 -->
        <van-popup v-model="assistant_show" class="pop_assistant">
            <div class="pop_assistant_box">
                <img :src="ewm_img" alt="公众号二维码" />
                <h3><span class="on">关注「新精英人才加速器」</span></h3>
			    <h4>了解课程详情</h4>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    data() {
        return{
        }
    },
    props:{
        assistant_show:{
            type:Boolean,
            default: false
        },
        ewm_img: {
            type: String,
            default: "@a/carrer.png"
        }
    }
}
</script>

<style lang="scss" scoped>
/*弹窗带二维码的*/

.pop_assistant {
    text-align: center;
    background-color: transparent;
    .pop_assistant_box {
        width: 600px;
        border-radius: 8px;
        background-color: #fff;
        padding: 105px 85px 84px;
        img {
            width: 434px;
            height: 434px;
        }
        h3 {
            margin-top: 44px;
            font-size: 34px;
            color: #333333;
            line-height: 50px;
            span.on {
                color: #EB5032;
            }
        }
        h4 {
            margin-top: 16px;
            font-size: 24px;
            color: #666;
            line-height: 20px;
        }
    }
}
</style>
